/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Artifact_Confirm_ApproveInputs */



/**
* | output |
* | --- |
* | "Create" |
*
* @param {Chat_Artifact_Confirm_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_artifact_confirm_approve = /** @type {((inputs?: Chat_Artifact_Confirm_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Artifact_Confirm_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen")
	return /** @type {LocalizedString} */ ("Create")
});